/* eslint-disable */


import {
  amber,
  blue,
  blueGrey,
  brown,
  cyan,
  deepOrange,
  deepPurple,
  green,
  grey,
  indigo,
  lightBlue,
  lightGreen,
  lime,
  orange,
  pink,
  purple,
  red,
  teal,
  yellow,
} from '@material-ui/core/colors';

/**
 * Create styles for `<ProfilePic />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<ProfilePic />` styles
 */
const profilePicStyles = ({ theme }) => ({
  /* eslint-disable sort-keys */ // This is disabled because techincally the order should be color1, color10, color11, ... color2 etc
  avatarFallbackColor1: {
    backgroundColor: red[500],
    color: theme.palette.getContrastText(red[500]),
  },
  avatarFallbackColor2: {
    backgroundColor: pink[500],
    color: theme.palette.getContrastText(pink[500]),
  },
  avatarFallbackColor3: {
    backgroundColor: purple[500],
    color: theme.palette.getContrastText(purple[500]),
  },
  avatarFallbackColor4: {
    backgroundColor: deepPurple[500],
    color: theme.palette.getContrastText(deepPurple[500]),
  },
  avatarFallbackColor5: {
    backgroundColor: indigo[500],
    color: theme.palette.getContrastText(indigo[500]),
  },
  avatarFallbackColor6: {
    backgroundColor: blue[500],
    color: theme.palette.getContrastText(blue[500]),
  },
  avatarFallbackColor7: {
    backgroundColor: lightBlue[500],
    color: theme.palette.getContrastText(lightBlue[500]),
  },
  avatarFallbackColor8: {
    backgroundColor: cyan[500],
    color: theme.palette.getContrastText(cyan[500]),
  },
  avatarFallbackColor9: {
    backgroundColor: teal[500],
    color: theme.palette.getContrastText(teal[500]),
  },
  avatarFallbackColor10: {
    backgroundColor: green[500],
    color: theme.palette.getContrastText(green[500]),
  },
  avatarFallbackColor11: {
    backgroundColor: lightGreen[500],
    color: theme.palette.getContrastText(lightGreen[500]),
  },
  avatarFallbackColor12: {
    backgroundColor: lime[500],
    color: theme.palette.getContrastText(lime[500]),
  },
  avatarFallbackColor13: {
    backgroundColor: yellow[500],
    color: theme.palette.getContrastText(yellow[500]),
  },
  avatarFallbackColor14: {
    backgroundColor: amber[500],
    color: theme.palette.getContrastText(amber[500]),
  },
  avatarFallbackColor15: {
    backgroundColor: orange[500],
    color: theme.palette.getContrastText(orange[500]),
  },
  avatarFallbackColor16: {
    backgroundColor: deepOrange[500],
    color: theme.palette.getContrastText(deepOrange[500]),
  },
  avatarFallbackColor17: {
    backgroundColor: brown[500],
    color: theme.palette.getContrastText(brown[500]),
  },
  avatarFallbackColor18: {
    backgroundColor: blueGrey[500],
    color: theme.palette.getContrastText(blueGrey[500]),
  },
  /* eslint-enable sort-keys */
  presence: {
    borderColor: theme.palette.background.default,
    borderRadius: `50%`,
    borderStyle: `solid`,
    borderWidth: theme.spacing(1) / 4,
    bottom: theme.spacing(1) / -4,
    display: `block`,
    height: theme.spacing(1) * 2,
    position: `absolute`,
    right: theme.spacing(1) / -4,
    width: theme.spacing(1) * 2,
  },
  presenceAway: {
    backgroundColor: amber[`A400`],
  },
  presenceOffline: {
    backgroundColor: red[`A400`],
  },
  presencePresent: {
    backgroundColor: lightGreen[`A400`],
  },
  presenceUnknown: {
    backgroundColor: grey[300],
  },
  root: {
    height: 40,
    position: `relative`,
    width: 40,
  },
});

export default profilePicStyles;
